// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uM32","largestCol":"styles_largestCol__5bBh-","smallestCol":"styles_smallestCol__3gMYQ"};